<script>
export default {
  name: 'PanelLegend',
  functional: true,
  props: {
    title: String
  },
  render (h, { props, slots, children }) {
    return (
      <div class="panel-content__legend">
        <h3 class="panel-content__legend-title">{props.title}</h3>
        <div class="panel-content__legend-content">
          {children}
        </div>
      </div>
    )
  }
}
</script>
